module.exports = __webpack_public_path__ + "img/beer_id-37.a6e1487e.png";